"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_TABLE_TEXT = exports.ROLE_TABLE_INDEX = exports.ROLE_TYPE_TEXT = exports.ROLE_TYPE_INDEX = void 0;
// used together  ------
var ROLE_TYPE_INDEX;
(function (ROLE_TYPE_INDEX) {
    ROLE_TYPE_INDEX[ROLE_TYPE_INDEX["BY_DAYS"] = 0] = "BY_DAYS";
    ROLE_TYPE_INDEX[ROLE_TYPE_INDEX["EMPLOYEE_COUNT"] = 1] = "EMPLOYEE_COUNT";
})(ROLE_TYPE_INDEX || (exports.ROLE_TYPE_INDEX = ROLE_TYPE_INDEX = {}));
exports.ROLE_TYPE_TEXT = ["曜日別", "スタッフごと"];
var ROLE_TABLE_INDEX;
(function (ROLE_TABLE_INDEX) {
    ROLE_TABLE_INDEX[ROLE_TABLE_INDEX["COUNT"] = 0] = "COUNT";
    ROLE_TABLE_INDEX[ROLE_TABLE_INDEX["WAGE"] = 1] = "WAGE";
})(ROLE_TABLE_INDEX || (exports.ROLE_TABLE_INDEX = ROLE_TABLE_INDEX = {}));
exports.ROLE_TABLE_TEXT = ["割り当て", "時給"];
